import { useForm } from 'react-hook-form';
import { fetchAPIPost } from '@/lib/connect';
import Input from '@/components/elements/input';
import Button from '@/components/elements/button';
import Link from '@/components/helper/link';
import ContentHeadline from '@/components/content/headline';
import { useState } from 'react';
import Select from '@/components/elements/select';
import moment from 'moment';
import Spinner from '@/components/elements/spinner';

export default function Newsletter() {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [serverErrors, setServerErrors] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const {
    getValues, register, handleSubmit, formState: { errors },
  } = useForm();

  const onSubmit = () => {
    setServerErrors(null);
    const fields = getValues();
    delete fields.terms;
    Object.keys(fields).forEach((key) => {
      if (fields[key] === '') {
        delete fields[key];
      }
    });
    setIsSending(true);
    if (fields.birthday && moment(fields.birthday, moment.ISO_8601).isValid()) {
      fields.birthday = moment(fields.birthday, moment.ISO_8601).format('DD.MM.Y');
    }
    fetchAPIPost('/newsletter', fields)
      .then(() => {
        setIsSending(false);
        setShowSuccessMessage(true);
      }).catch((json) => {
        setIsSending(false);
        setServerErrors(json.errors);
      });
  };

  function RenderServerErrors() {
    const errors = [];
    Object.keys(serverErrors).forEach((k) => {
      serverErrors[k].map((e) => errors.push(e));
    });
    return (
      <ul className="list-disc">
        {errors.map((e, i) => (
          <li key={i} className="ml-4 text-red-800">{e}</li>
        ))}
      </ul>
    );
  }

  return (
    <section className="max-w-7xl mx-auto w-full px-6 xl:px-0 mt-24">
      <ContentHeadline before="Newsletter">abonnieren</ContentHeadline>
      <p>
        Abonnieren Sie unseren Newsletter, um keine unserer besten Angebote, neuesten Nachrichten, Artikel und vieles
        mehr zu verpassen.
      </p>
      {showSuccessMessage && (
        <div className="mt-2 p-3 bg-primary text-white">
          Sie haben sich erfolgreich für unseren Newsletter angemeldet. Danke für die Registrierung.
        </div>
      )}
      {serverErrors !== null && (
        <div className="border-red-800 border p-2 mt-5">
          <p>Leider sind beim Speichern folgende Fehler aufgetreten</p>
          <RenderServerErrors />
        </div>
      )}
      <div className="relative">
        <form
          className={`max-w-7xl m-auto pt-5 grid md:grid-cols-2 gap-5 ${isSending ? 'opacity-50' : ''} ${showSuccessMessage ? 'hidden' : ''}`}
          onSubmit={handleSubmit(onSubmit)}
        >
          <Select
            label="Anrede"
            id="salutation"
            name="salutation"
            register={{ ...register('salutation', { required: true }) }}
          >
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <option value="" disabled hidden className="text-gray-500">Bitte wählen</option>
            <option value="Frau">Frau</option>
            <option value="Herr">Herr</option>
          </Select>
          <Select
            label="Titel"
            id="title"
            name="title"
            register={{ ...register('title', { required: false }) }}
          >
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <option value="" hidden className="text-gray-500">-</option>
            <option value="Dr.">Dr.</option>
            <option value="Prof.">Prof.</option>
          </Select>
          <Input
            type="text"
            label="Vorname *"
            placeholder="Vorname"
            name="firstname"
            error={errors?.firstname}
            register={{ ...register('firstname', { required: true, maxLength: 80 }) }}
          />
          <Input
            type="text"
            label="Nachname *"
            placeholder="Nachname"
            name="lastname"
            error={errors?.lastname}
            register={{ ...register('lastname', { required: true, maxLength: 100 }) }}
          />
          <Input
            type="text"
            label="Email *"
            placeholder="Email"
            name="email"
            error={errors?.email}
            register={{ ...register('email', { required: true, pattern: /^\S+@\S+$/i }) }}
          />
          <Input
            type="tel"
            label="Handynummer"
            placeholder="Handynummer"
            name="mobile"
            error={errors?.mobile}
            register={{ ...register('mobile', { required: false, minLength: 6, maxLength: 15 }) }}
          />
          <Input
            type="date"
            label="Geburtsdatum"
            name="birthday"
            register={{ ...register('birthday', { required: false }) }}
          />
          <div className="flex items-center">
            <input
              type="checkbox"
              id="newsletter-agb"
              placeholder="agb"
              name="terms"
              {...register('terms', { required: true })}
            />
            <label
              htmlFor="newsletter-agb"
              className={`ml-2 text-sm md:text-base ${errors?.terms ? 'text-red-600' : ''}`}
            >
              Ich stimme den
              {' '}
              <Link href="/datenschutz">
                <a className="text-primary">Datenschutzbedingungen</a>
              </Link>
              {' '}
              zu *
            </label>
          </div>
          <p className="text-sm">Mit * gekennzeichnete Felder sind Pflichtfelder</p>
          <Button type="submit">abonnieren</Button>
        </form>
        {isSending && (
          <Spinner classNames="h-10 w-10 absolute left-[48%] top-[40%]" />
        )}
      </div>
    </section>
  );
}
